import { useEffect, useState } from "react";
import {
  Box, Grid, Card, CardContent,
  Typography, CircularProgress
} from "@mui/material";

import { userService } from "../service/UserService";
import { filterBikeService } from "../service/FilterBikeService";
import { soldBikeService } from "../service/SoldBikeService";
import { exchangeBikeService } from "../service/ExchangeBikeService";
import { showroomService } from "../service/ShowroomService";

const StatCard = ({ title, value }) => (
  <Card>
    <CardContent>
      <Typography color="textSecondary">{title}</Typography>
      <Typography variant="h4">
        {value === null ? <CircularProgress size={20} /> : value}
      </Typography>
    </CardContent>
  </Card>
);

const DashboardHome = () => {

  const [stats, setStats] = useState({
    users: null,
    stock: null,
    sold: null,
    exchange: null,
    revenue: null,
    profit: null,
    showroom: null
  });

  const fetchData = async () => {
    try {

      // 👥 Users
      const users = await userService.getAllUsers();

      // 📦 Stock  (CHANGED: limit removed, backend returns all matches)
      const stock = await filterBikeService.getFilteredBikes({
        status: "IN_STOCK"
      });

      // 💰 Sold
      const sold = await soldBikeService.getSoldBikes();

      let totalSold = 0;
      let totalRevenue = 0;

      sold.data?.forEach(loc => {
        totalSold += loc.totalSold || 0;
        loc.bikes?.forEach(b => {
          totalRevenue += b.salePrice || 0;
        });
      });

      // 🔁 Exchange
      const exchange = await exchangeBikeService.getExchangeBikes();
      let totalExchange = 0;
      exchange.data?.forEach(loc => {
        totalExchange += loc.totalExchange || 0;
      });

      // 🏆 Showroom
      const showroom = await showroomService.getPerformance();

      let totalProfit = 0;
      showroom.data?.forEach(s => {
        totalProfit += s.totalProfit || 0;
      });

      setStats({
        users: users.length,
        stock: stock.total ?? stock.data?.length ?? 0, // CHANGED: was stock.pagination?.total
        sold: totalSold,
        exchange: totalExchange,
        revenue: totalRevenue,
        profit: totalProfit,
        showroom: showroom.data?.length || 0
      });

    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Dashboard Overview
      </Typography>

      <Grid container spacing={3}>

        <Grid item xs={12} md={3}>
          <StatCard title="Total Users" value={stats.users} />
        </Grid>

        <Grid item xs={12} md={3}>
          <StatCard title="Available Stock" value={stats.stock} />
        </Grid>

        <Grid item xs={12} md={3}>
          <StatCard title="Sold Bikes" value={stats.sold} />
        </Grid>

        <Grid item xs={12} md={3}>
          <StatCard title="Exchange Bikes" value={stats.exchange} />
        </Grid>

       

        <Grid item xs={12} md={3}>
          <StatCard title="Showrooms" value={stats.showroom} />
        </Grid>

      </Grid>
    </Box>
  );
};

export default DashboardHome;